import { z } from "zod";

const BlogCategorySchema = z.enum(["Corporate", "PV plant provider", "DEC Energy", "Mercato"]);

export const BlogPostSummarySchema = z.object({
  // DRF serializes the PK as a JSON number; coerce so the id is a string
  // everywhere on the client (used verbatim in the `?id=` link + detail URL).
  id: z.coerce.string(),
  category: BlogCategorySchema,
  title: z.string(),
  created_at: z.string(),
  image: z.string(),
  author: z.string(),
  body_images: z.array(z.string()).optional(),
  language: z.string().optional(),
});
export type BlogPostSummary = z.infer<typeof BlogPostSummarySchema>;

export const BlogPostSchema = BlogPostSummarySchema.extend({
  body: z.string(),
});
export type BlogPost = z.infer<typeof BlogPostSchema>;
